export const formatCurrency = (amount: number, userLocale: string, userCurrency: string): string => {
	try {
		return new Intl.NumberFormat(userLocale, {
			style: 'currency',
			currency: userCurrency,
			maximumFractionDigits: 0
		}).format(amount);
	} catch (err) {
		console.warn('Failed to format tuition', err);
		return `${amount} ${userCurrency}`;
	}
};